<template>
  <OnboardingAiLayout>
    <OnboardingAiFlow @exit="closeOnboarding" />
  </OnboardingAiLayout>
</template>

<script setup>
import OnboardingAiFlow from '@/components/ui/onboarding-ai/OnboardingAiFlow'
import OnboardingAiLayout from '@/components/ui/onboarding-ai/OnboardingAiLayout'

defineOptions({
  name: 'OnboardingAiHub'
})

const emit = defineEmits({
  'close-onboarding-ai': null
})

const closeOnboarding = () => {
  emit('close-onboarding-ai')
}
</script>
